import { z } from 'zod';
import { pelRegionSchema, pelContractorTypeSchema } from '../../enums.mjs';
import { nonNegativeCurrencySchema, positiveCurrencySchema, currencySchema } from '../../types/utils.mjs';

var Calculate;
(function (Calculate) {
    (function (Request) {
        Request.schema = z
            .object({
            totalExposure: positiveCurrencySchema,
            bondAmount: nonNegativeCurrencySchema,
            contractorType: pelContractorTypeSchema,
            region: pelRegionSchema,
        })
            .refine(({ bondAmount, totalExposure }) => bondAmount <= totalExposure, {
            path: ["bondAmount"],
            error: "Cannot exceed total exposure",
        });
    })(Calculate.Request || (Calculate.Request = {}));
    (function (Response) {
        Response.schema = z.object({
            concentrationRatio: z.number(),
            basePercent: z.number(),
            concentrationPercent: z.number(),
            regionPercent: z.number(),
            pelPercent: z.number(),
            pelAmount: currencySchema,
            pml90Percent: z.number(),
            pml90Amount: currencySchema,
            pml95Percent: z.number(),
            pml95Amount: currencySchema,
        });
    })(Calculate.Response || (Calculate.Response = {}));
})(Calculate || (Calculate = {}));
var ForQuote;
(function (ForQuote) {
    (function (Request) {
        Request.schema = z
            .object({
            contractorType: pelContractorTypeSchema.optional(),
            region: pelRegionSchema.optional(),
        })
            .default({});
    })(ForQuote.Request || (ForQuote.Request = {}));
    (function (Response) {
        Response.schema = z.object({
            bondAmount: currencySchema,
            accountBondExposure: currencySchema,
            suggestedContractorType: pelContractorTypeSchema.nullable(),
            suggestedRegion: pelRegionSchema.nullable(),
            contractorType: pelContractorTypeSchema.nullable(),
            region: pelRegionSchema.nullable(),
            thisBond: Calculate.Response.schema.nullable(),
            accountContext: Calculate.Response.schema.nullable(),
        });
    })(ForQuote.Response || (ForQuote.Response = {}));
})(ForQuote || (ForQuote = {}));

export { Calculate, ForQuote };
